<script lang="ts" setup>
defineProps<{
  loading: boolean;
  error?: string;
  loadingTitle?: string;
}>();
</script>
<template>
  <template v-if="loading">
    <div class="flex flex-col items-center justify-center pt-[40vh]">
      <ui-icon name="Loader" class="animate-spin text-emerald-600 !h-[40px] !w-[40px]" />
      <div v-if="loadingTitle" class="mt-4 select-none text-gray-400 text-base">{{ loadingTitle }}</div>
    </div>
  </template>
  <template v-else>
    <slot />
  </template>
</template>
